const INVALID_FINISHED_REASONS = new Set([
  "FINAL_DOUBLE_NO_SHOW",
  "NO_VALID_FINALISTS",
]);

export function isInvalidFinishedTournament(tournament = {}) {
  const status = String(tournament?.status || "").toLowerCase();
  const finishReason = String(tournament?.finishReason || "").toUpperCase();
  return status === "finished" && !tournament?.winnerUid && INVALID_FINISHED_REASONS.has(finishReason);
}

export function getTournamentStatusKeyForCard(tournament = {}, options = {}) {
  const status = String(tournament.status || "open").toLowerCase();
  const playerCount = Number(options.playerCount ?? tournament.participantCount ?? 0);
  const maxPlayers = Number(options.maxPlayers ?? tournament.maxPlayers ?? 0);
  const isFull = maxPlayers > 0 && playerCount >= maxPlayers;
  const winnerUid = tournament.winnerUid || null;
  const isVoid = tournament.voided || tournament.isVoid || status === "void" || status === "invalid";

  if (isVoid || isInvalidFinishedTournament(tournament)) return "invalid";
  if (status === "finished" || status === "completed" || winnerUid || tournament.finishedAt) return "finished";
  if (status === "running") return "running";
  if (status === "cancelled" || status === "canceled" || status === "did_not_start" || status === "not_started") return "didNotStart";
  if (status === "full" || status === "closed" || isFull) return "closed";

  return "open";
}
